import React from 'react';
import { Platform, StatusBar, StyleSheet, View } from 'react-native';
import ReactGA from 'react-ga';
import * as SplashScreen  from 'expo-splash-screen';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import useLinking from './navigation/useLinking';

//screens to route between
import LandingScreen from './screens/NewLanding';
import CheckListScreen from './screens/CheckListScreen';
import BrowseCampaignScreen from './screens/BrowseCampaigns';
import AboutScreen from './screens/AboutScreen';

const Stack = createStackNavigator();
ReactGA.initialize('UA-197162860-1');
export default function App(props) {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);
  const [initialNavigationState, setInitialNavigationState] = React.useState();
  const containerRef = React.useRef();
  const { getInitialState } = useLinking(containerRef);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();
        // Load our initial navigation state
        setInitialNavigationState(await getInitialState());
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  if (!isLoadingComplete && !props.skipLoadingScreen) {
    return null;
  } else {
    return (
      <View style={styles.container}>
        {Platform.OS === 'ios' && <StatusBar barStyle="default" />}
        <NavigationContainer ref={containerRef} initialState={initialNavigationState}>
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen name="Landing" component={LandingScreen} />
            <Stack.Screen name="Campaign" component={CheckListScreen} getId={({ params }) => params.id}/>
            <Stack.Screen name="Browse" component={BrowseCampaignScreen} />
            <Stack.Screen name="About" component={AboutScreen} />
            {/* <Stack.Screen name="Admin" component={CampaignEditor} /> */}
          </Stack.Navigator>
        </NavigationContainer>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
});
